import React from 'react';
import { useGuideTheme } from './guideBlocks';

const CreationSetupGuide: React.FC = () => {
  const { dsColors, heroPrimary, heroSecondary, cardBorder } = useGuideTheme();
  const items: [string, string][] = [
    [
      'Requirements',
      'Open Requirements, then Who Can Join. Choose rider experience and, for riding events, Minimum Engine Size. Leave it unset when any engine size is acceptable. Minimum Engine Size is a lower bound, not an exact displacement match. The iOS eligibility check allows a 5% manufacturer tolerance, so a 1000cc minimum accepts recorded displacement from 950cc upward; missing displacement data can make a motorcycle ineligible. Pro unlocks Specific Brands Only and Required Bike Colors.',
    ],
    [
      'Ride crew',
      'Open Ride Crew and turn on Open Volunteering if participants should be able to request roles. Use Manage Crew to select friends to invite as Co-Host, Road Captain, Sweep or Tailgunner. Invitations are sent after creation and must be accepted; selecting a friend does not assign a role automatically. Review requests later in Manage Crew.',
    ],
    [
      'Sponsors',
      'Open Sponsors, then Add Sponsors. Choose a saved sponsor or add one with a name, optional website and logo, then choose Title, Partner or Supporter. Finish editing and tap Done in Event Sponsors to keep the list for publication. Free supports up to 2 sponsors and Pro up to 5; basic sponsor presentation and tier choices are available without Pro.',
    ],
    [
      'Weather',
      'After publication, open the event details and Weather. Forecasts target the meetup place and time and are available within 7 days of the event. Completed or cancelled events can show a saved snapshot when one exists. Service or network failures may offer Try Again; no-data and out-of-window states do not. Weather is informational, not an alert or safety service.',
    ],
    [
      'Appearance',
      'Under Card Theme, open Look & Feel and choose an event theme with Pro. Add Visuals lets Pro hosts attach a flyer and video. These optional choices do not replace the event plan.',
    ],
  ];
  return (
    <details className="mt-8 rounded-xl" style={{ border: `1px solid ${cardBorder}` }}>
      <summary
        className="cursor-pointer select-none font-semibold text-base px-5 py-3 rounded-xl focus:outline-none focus-visible:ring-2"
        style={{ color: heroPrimary, minHeight: '44px', '--tw-ring-color': dsColors.primary } as React.CSSProperties}
      >
        More event setup options
      </summary>
      <div className="px-5 pb-5 pt-1">
        {items.map(([title, text]) => (
          <div key={title} className="mt-4">
            <h4 className="text-sm font-bold mb-1" style={{ color: heroPrimary }}>{title}</h4>
            <p className="text-sm leading-relaxed" style={{ color: heroSecondary, textWrap: 'pretty' }}>{text}</p>
          </div>
        ))}
      </div>
    </details>
  );
};

export default CreationSetupGuide;
